module.exports = __webpack_public_path__ + "static/img/post-grad-salaries.18d0124.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/post-grad-salaries.jpg
// module id = blUE
// module chunks = 1